import { composeIO } from 'react-compose-io'
import { fieldsAritmeticaIO } from './FieldsAritmetica.IO'
import { FieldsAritmeticaView } from './FieldsAritmetica.View'

export const FieldsAritmetica = composeIO(FieldsAritmeticaView, fieldsAritmeticaIO)
